import { createLogger } from '@lsk4/log';
// import { createLogger } from './createLogger.js';

export const log = createLogger({ ns: 'cli' });

// log.log('hello world');
// log.trace('hello world');
// log.debug('hello world');
// log.info('hello world');
// log.warn('hello world');
// log.error('hello world');
// log.fatal('hello world');
